import React, { useEffect, useState } from "react";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { EyeIcon, EditIcon, Trash2Icon } from "lucide-react";
import { Tooltip } from "react-tooltip";
import TableHeader from "../Utility/TableHeader";
import axios from "axios";
import { toast } from "react-toastify";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { Pagination } from "../../helper/HelperTwo";
function LeadRoleAssignList({
  setIsLeadRoleAssignDialogOpen,
  setLoading,
  setFormData,
  setSaveBtn,
  seteditIdCryptForRollAssign,
  leadRoleAssignData,
  fetchRollAssignData,
  rolesAssignPermission,
  paginationLeadRoleAssign,
  setCurrentPage
}) {
  const user = JSON.parse(localStorage.getItem("user"));

  const headers = ["S No", "Employee Name", "Role Name", "Status", "Action"];

 

  const handleEditForRollAssign = async (id_crypt) => {
    setSaveBtn("update");
    seteditIdCryptForRollAssign(id_crypt);
    const token = localStorage.getItem("token");
    setIsLeadRoleAssignDialogOpen(true);
    try {
      const editresponse = await axios.get(
        `public/api/admin/leadroleassign/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (editresponse.data) {
        setFormData((prevData) => ({
          ...prevData,
          employee_id: editresponse.data.roleassign.employee_id,
          role_id: editresponse.data.roleassign.role_id,
          status_id: editresponse.data.roleassign.status_id,
        }));
      }

    } catch (error) {
      toast.error(error.editresponse?.data?.message || "Failed to fetch data");
    }
  };

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
 
      setCurrentPage(newPage);
      fetchRollAssignData(newPage);
    }
  };

  return (
    <div className="grid md:grid-cols-1 gap-4">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-300 mt-8">
          <TableHeader headers={headers} />
          <tbody className="divide-y divide-gray-200 bg-white">
            {Array.isArray(leadRoleAssignData?.data) &&
            leadRoleAssignData.data.length > 0 ? (
              leadRoleAssignData?.data.map((item, index) => (
                <tr
                  key={item.id}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="py-4 px-4 text-center  whitespace-nowrap font-medium">
                    {index + 1}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {item.employees?.name || "N/A"}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500  whitespace-nowrap">
                    {item.role?.name || "N/A"}
                  </td>
                  <td
                    className={`py-4 px-4 text-center text-md ${
                      item.status_id === 1 ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {item.status_id === 1 ? "Active" : "Inactive"}
                  </td>
                  <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {rolesAssignPermission && (
                      <span
                        className="my-anchor-edit relative group cursor-pointer bg-green-400 rounded-md p-1"
                        onClick={() => handleEditForRollAssign(item.id_crypt)}
                      >
                        <PencilSquareIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-edit"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Edit
                        </Tooltip>
                      </span>
                    )}

                    {rolesAssignPermission && (
                      <DeleteConfirmation
                        id_crypt={item.id_crypt}
                        apiType="roleassign"
                        fetchClientData={fetchRollAssignData}
                        setLoading={setLoading}
                      />
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>

         {paginationLeadRoleAssign && (
              <Pagination
              links={paginationLeadRoleAssign.links}
              currentPage={paginationLeadRoleAssign.current_page}
              totalResults={paginationLeadRoleAssign.total}
              from={paginationLeadRoleAssign.from}
              to={paginationLeadRoleAssign.to}
              lastPage={paginationLeadRoleAssign.last_page}
              onPageChange={handlePageChange}
              />
              )}
      </div>
    </div>
  );
}

export default LeadRoleAssignList;
